import React from "react";
import BottomTabNavigator from "../components/BottomTabNavigator";
import Footer from "./Footer";
import Navbar from "./Navbar";
import BackToTop from "../components/BackToTop";
import FloatingIcon from "../components/FloatingIcon";
import TranslateWidget from "../components/translateWidget";

const Layout = (props) => {
  return (
    <div className="relative">
      {/* <TranslateWidget /> */}
      <Navbar />
      {props.children}
      <BackToTop />
      <FloatingIcon />
      <Footer />
      <BottomTabNavigator />
    </div>
  );
};

export default Layout;
